import { AfterViewInit, Component, ElementRef, NgZone, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, NgForm, Validators } from "@angular/forms";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { AuthService } from "../../main/auth.service";
import { ClientService } from "../";
import { environment } from "../../../environments/environment";
import { ArkUserType, ClientModel, ClientUserViewModel, ClientViewModel, JwTokenModel, UserModel } from "../../core/api/models";
import { HttpClient, HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { map, tap } from "rxjs/operators";
import { Utils } from "../../core/utils";
import { AlertService } from "../../shared/services/alert.service";
import { ClientsApiService, ClientUsersApiService } from "../../core/api/services";
import { Table } from "primeng/table";
import { DomSanitizer } from "@angular/platform-browser";



interface AutoCompleteCompleteEvent {
  originalEvent: Event;
  query: string;
}

@Component({
  selector: 'app-client-list-component',
  templateUrl: './client-list.component.html',
  standalone: false
})
export class ClientListComponent implements OnInit, AfterViewInit {
  

  public pageTitle: string = 'Clients';

  filter: any = {};
  list: any = undefined;
  loadingList: boolean = true;


  @ViewChild('itemForm') itemForm!: NgForm;

  @ViewChild('dt1') table?: Table;;
  
  itemFormGroup!: FormGroup;
  currentItem?: ClientModel;


  baseDomain: string | null = environment.baseDomain;

  clientLoginItem?: ClientViewModel;
  clientLoginVisible: boolean = false;
  clientLoginUrl: string | null = null;

  client_user: any | null = null;
  filteredClientUser: ClientUserViewModel[] = [];

  loading: boolean = false;
  loadingClientUsers: boolean = false;
  private clientUserSearchRequest = 0;
  constructor(private authService: AuthService,
    private clientService: ClientService,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private apiService: ClientsApiService,
    private clientUsersApi: ClientUsersApiService,
    private sanitizer: DomSanitizer,
    private formBuilder: FormBuilder) {
  }


  ngOnInit(): void {


    this.route.paramMap.subscribe((params: ParamMap) => {
      let ID = + ( params.get('ID') || '0');
      if (ID > 0) {
        console.info('Loading ' + ID);

      this.apiService.Get({ body: { id: ID } })
        .forEach(data => {
          this.loadingList = false;
          this.currentItem = data;
          this.load();
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));

          });

      }
    });


    this.authService.checkIfAutorized([ArkUserType.Marketing, ArkUserType.Admin, ArkUserType.Impersonator]);


    this.itemFormGroup = this.formBuilder.group(
      {

        //userId: [],
        SiteName: ['', [Validators.required, Validators.maxLength(50)]],
        BusinessGroupName: ['', [Validators.maxLength(255)]],
        BusinessName: ['', [Validators.maxLength(255)]],
        Email: ['', [Validators.maxLength(255), Validators.email]],
        PhoneNumber: ['', [Validators.maxLength(25)]],
        Active: [true, []],
        DateCreated: []
      });


  }

  ngAfterViewInit(): void {
    
    /*
    this.filter = {
      filters: {
        "Active": [
          {
            "value": "true",
            "matchMode": "contains",
            "operator": "and"
          }
        ]
      }
    }; 
    ;
    */
    
  }



  loadTable(event: any) {

    if (event || !this.filter) {
      this.filter = Utils.normalizePrimeDatatableEvent(event || this.filter || { filters: {} });
    }


    this.loadingList = true;
    this.apiService.List({ body: this.filter })
      .forEach(
        (result) => {
          this.list = result;
          this.loadingList = false;
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
            this.loadingList = false;
          });
  }



  getClientLogo(client: ClientViewModel | ClientModel): any {

    return this.clientService.getClientLogo(client, 'Print');
  }


  clear(table: Table) {
    this.table = table;
    table.clear();
  }


  addItem(table: Table) {
    this.alertService.info('TO DO - Add new client');
  }


  onRowView(item: ClientViewModel) {
    this.clientLoginItem = item;
    this.client_user = null;
    this.clientLoginUrl = null;
    this.clientLoginVisible = true;


    this.authService.user().forEach((user) => {
      if (user?.UserHasClients) {
        this.filteredClientUser = user.UserHasClients.filter((x) =>
          x.ClientID == item.ID //|| !environment.production
        ).map((x) => {
          return {
            ID: x.Client_UserID,
            UserName: x.Client_Username,
            FirstName: user.FirstName,
            LastName: user.LastName,
            Email: user.Email,
            UserType: 'ME'
          } as ClientUserViewModel;
        });
        if (this.filteredClientUser.length > 0)
          this.client_user = this.filteredClientUser[0];
      }
    });

    /*
    this.loadingClientUsers = true;
    this.apiService.GetClientUsers({ body: { clientID: item.ID || 0 } })
      .forEach((result) => {
        this.loadingClientUsers = false;
        this.client_users = result.filter(x => x.Inactive == false);

        
        this.client_userID =
          this.client_users.find(x => x.ID == myClient_userID)?.ID ||
          this.client_users.find(x => x.UserName == this.authService.userInfo?.UserName)?.ID ||
          this.client_users.find(x => x.Email == this.authService.userInfo?.Email)?.ID ||
          this.client_users.find(x => x.FirstName == this.authService.userInfo?.FirstName && x.LastName == this.authService.userInfo?.LastName)?.ID ||
          null;
        
        
        if (!this.client_userID  && this.client_users && this.client_users.length > 0)
          this.client_userID = this.client_users[0]?.ID;
        
      }).catch(
        err => {
          this.loadingClientUsers = false;
          this.alertService.error(Utils.getAjaxError(err));
        });
    */
  }


  labelClientUser(item: any) {
    let name = `${item.UserName} - ${item.FirstName || ''} ${item.LastName || ''}`;
    if (item.UserType)
      return `${name} [${item.UserType}]`;
    if (item.Inactive)
      return `${name} [INACTIVE]`;
    if (item.Hidden)
      return `${name} [Hidden]`;
    return name;
  }

  filterClientUsers(event: AutoCompleteCompleteEvent) {
    const clientID = this.clientLoginItem?.ID;
    if (!clientID) return;
    const request = ++this.clientUserSearchRequest;
    let filtered: any[] = [];
    let query = event.query;
    if (query.indexOf('[') > 0)
      query = query.substring(0, query.indexOf('[')).trim();
    if (query.indexOf(' - ') > 0)
      query = query.substring(0, query.indexOf(' - ')).trim();

    this.loadingClientUsers = true;
    //this.filteredClientUser =[] ;
    this.clientUsersApi.Search({
      clientID,
      body: {
        prefixText: query,
        count: 25
      }
    })
      .forEach((result) => {
        if (this.clientLoginItem?.ID !== clientID || request !== this.clientUserSearchRequest) return;
        this.loadingClientUsers = false;
        this.filteredClientUser = result;
      }).catch(
        err => {
          if (this.clientLoginItem?.ID !== clientID || request !== this.clientUserSearchRequest) return;
          this.loadingClientUsers = false;
          this.alertService.error(Utils.getAjaxError(err));
        });

  }

  clientLogin() {

    if (!this.client_user) {
      this.alertService.error('Please select a client user');
      return;
    }
    this.loading = true;
    this.apiService.GetImpersonationLink({ body: { clientID: this.clientLoginItem!.ID || 0, client_userID: this.client_user.ID ||0 } }).forEach((r) => {
      this.loading = false;
      this.clientLoginUrl = r;
      var w = window.open(r, this.clientLoginItem!.SiteName || '_blank');
      if (w) {
        this.clientLoginVisible = false;
      }
    }).catch(
      err => {
        this.alertService.error(Utils.getAjaxError(err));
        this.loading = false;
      }).
      finally(() => {
      });


  }

  onRowEditInit(item: ClientViewModel) {

    this.loadingList = true;


    this.apiService.Get({ body: { id: item.ID || 0 } })
      .forEach(data => {
        this.loadingList = false;
        this.currentItem = data;
        this.load()


      }).catch(
        (err) => {
          this.alertService.error(Utils.getAjaxError(err));
        });

  }




  load() {
    if (!this.currentItem)
      return;
    console.info(this.currentItem);
    if (this.itemForm)
      this.itemForm.resetForm();
    if (this.itemFormGroup)
      this.itemFormGroup.clearValidators();

    this.itemFormGroup.patchValue(this.currentItem);

  }

  cancel() {
    this.currentItem = undefined;
    if (this.itemForm)
      this.itemForm.resetForm();
  }

  save() {

    if (!this.itemFormGroup.valid) {

      const errors = Utils.getFormErrors(this.itemFormGroup);

      if (errors.length > 0) {
        this.alertService.error(errors.join(' \n'));
        return;
      }
    }
    var formValue = this.itemFormGroup.getRawValue();

    let newItem =
    {
      ...this.currentItem,
      ...formValue
    }
    console.info(this.currentItem);
    

    this.loading = true;
    this.apiService.Save({ body: newItem })
      .forEach(
        (savedItem) => {

          this.loading = false;
          this.currentItem = undefined;
          if (this.itemForm)
            this.itemForm.resetForm();
          this.alertService.success('Item saved successfully');
          this.loadTable(null);

        }).catch (
          err => {
            this.loading = false;
            this.alertService.error(Utils.getAjaxError(err));
          
        });


  }

}
